"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuSelect = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_hooks_1 = require("@hopin-team/ui-helper-hooks");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var react_1 = tslib_1.__importStar(require("react"));
var context_1 = require("../context");
var select_1 = require("../styled/select");
var MenuSelect = function (_a) {
    var __UIScope = _a.__UIScope, children = _a.children, className = _a.className, testID = _a["data-testid"], labelledById = _a.labelledById, _b = _a.role, role = _b === void 0 ? 'menu' : _b, _c = _a.currentIndex, currentIndex = _c === void 0 ? 0 : _c;
    var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
        block: 'MenuSelect',
        className: className,
        __UIScope: __UIScope,
    }).rootClasses;
    var selectRef = (0, react_1.useRef)(null);
    var _d = tslib_1.__read((0, react_1.useState)(currentIndex), 2), focusedIndex = _d[0], setFocusedIndex = _d[1];
    var pattern = (0, react_1.useContext)(context_1.MenuContext).pattern;
    var childrenCount = react_1.Children.toArray(children).filter(function (c) { return !!c; }).length;
    (0, react_1.useEffect)(function () {
        var _a;
        var items = (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.childNodes;
        if (focusedIndex >= 0 && focusedIndex < childrenCount && items) {
            items[focusedIndex].focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [focusedIndex]);
    var onArrowDownKey = function (e) {
        if (focusedIndex === childrenCount - 1) {
            setFocusedIndex(0);
        }
        else {
            setFocusedIndex(focusedIndex + 1);
        }
        e.preventDefault();
    };
    var onArrowUpKey = function (e) {
        if (focusedIndex === 0) {
            setFocusedIndex(childrenCount - 1);
        }
        else {
            setFocusedIndex(focusedIndex - 1);
        }
        e.preventDefault();
    };
    (0, ui_helper_hooks_1.useOnKeyPress)('ArrowDown', onArrowDownKey);
    (0, ui_helper_hooks_1.useOnKeyPress)('ArrowUp', onArrowUpKey);
    return (react_1.default.createElement(select_1.Select, { className: rootClasses, "data-testid": testID, role: role, ref: selectRef, "aria-labelledby": labelledById, isDouble: pattern === 'double' }, children));
};
var MenuSelectWithSpace = (0, ui_helper_with_space_1.withSpace)(MenuSelect);
exports.MenuSelect = MenuSelectWithSpace;
//# sourceMappingURL=menu-select.js.map